import {
  Directive,
  Renderer2,
  ElementRef,
  OnInit,
  OnDestroy,
  Input
} from '@angular/core';
import { ButtonLoaderStateService } from '../services/button-loader-state.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Directive({
  selector: '[abButtonLoader]'
})
export class ButtonLoaderDirective implements OnInit, OnDestroy {
  @Input('abButtonLoader') index: string;
  private subscriptions: Subscription[] = [];

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private buttonLoaderStateService: ButtonLoaderStateService
  ) {}

  ngOnInit() {
    if (this.index === '') {
      this.subscriptions.push(
        this.buttonLoaderStateService.loaderState.subscribe(isLoading => {
          this.toggleState(isLoading);
        })
      );
    } else {
      this.subscriptions.push(
        this.buttonLoaderStateService.loaderStateWithIndex.subscribe(
          requests => {
            Object.keys(requests).forEach(key => {
              if (key.indexOf(this.index) !== -1) {
                this.toggleState(requests[key]);
              }
            });
          }
        )
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private toggleState(isLoading: boolean) {
    if (isLoading) {
      this.renderer.addClass(this.el.nativeElement, 'btn-loader');
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'disabled');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'btn-loader');
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
  }
}
